<template>
  <v-tooltip top>
    <v-btn :disabled="disabledButton" icon slot="activator" @click="cancel()">
      <v-icon color="red">remove_circle</v-icon>
    </v-btn>
    <span>Cancel</span>
  </v-tooltip>
</template>

<script>
export default {
  props: {
    disabledButton: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    cancel() {
      this.$emit("cancel");
    }
  }
};
</script>